import type { IdentityGateway } from './IdentityGateway';
import { HttpIdentityGateway } from './HttpIdentityGateway';
import { MockIdentityGateway } from './MockIdentityGateway';

const useMocks = (import.meta.env.VITE_USE_MOCKS ?? 'true').toLowerCase() !== 'false';

// Deliberately relative, not VITE_API_BASE_URL — the browser must see the API as the SAME origin the
// page was served from (this app's cookies are SameSite=Strict, with no separate CSRF-token defense,
// so same-origin is the actual security boundary, not an implementation detail). In dev, Vite's own
// server proxy (vite.config.ts) forwards /api and /health to VITE_API_BASE_URL behind the scenes; in
// production this means the API must be reverse-proxied under the same origin as these static assets.
export const identityGateway: IdentityGateway = useMocks ? new MockIdentityGateway() : new HttpIdentityGateway('');
export const isMockGateway = useMocks;
